
import { namespace } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import * as contact from '~/store/modules/contact'
import * as sq from '~/store/modules/sq'

import ServiceQualification from '~/components/ServiceQualification.vue'
import Phone from '~/components/Icons/Phone.vue'
import Mail from '~/components/Icons/Mail.vue'
import AddressBar from '~/components/Plans/AddressBar.vue'
import Location from '~/components/Icons/LocationMarker.vue'
import GenericContactForm from '~/components/ContactForm/Contact.vue'
import Wechat from '~/components/Icons/Wechat.vue'

const Contact = namespace(contact.name)
const Sq = namespace(sq.name)

@Component({
  head() {
    return {
      title: `Contact Us - ${this.brand.name}`,
      meta: [
        {
          hid: 'Contact',
          name: 'description',
          content: `Contact ${this.brand.name} on ${
            this.brand.phone
          } and speak with our friendly customer support. We're easy to reach in our Sydney based call centre and here to help.`
        }
      ]
    }
  },
  components: {
    ServiceQualification,
    Mail,
    Phone,
    AddressBar,
    Location,
    GenericContactForm,
    Wechat
  },
  data() {
    return {
      siteId: process.env.siteId,
      brand: process.env.brand
    }
  }
})
export default class ContactForm extends Vue {
  @Contact.Action
  create
  
  @Contact.Action
  validate

  @Sq.Getter
  sq

  error = false

  sending = false

  sent = false

  async mounted() {
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e);
    }
  }

  async handleSubmit(event: ContactForm) {
    try {
      this. sending = true
      const token = await this.$recaptcha.getResponse()
      await this.validate({...event, token})
      await this.$recaptcha.reset()
      await this.create(event)

      this.sending = false;
      this.sent = true;
    } catch(e: unknown) {
      this.error = true
    }
  }
}
